import script from "./tree.vue?vue&type=script&setup=true&lang=js"
export * from "./tree.vue?vue&type=script&setup=true&lang=js"

import "./tree.vue?vue&type=style&index=0&id=47154b6c&lang=css"

const __exports__ = script;

export default __exports__